<template>
  <div>
    <loading-block v-if="!loaded"></loading-block>
    <v-card v-else style="padding-bottom:80px;">
      <v-card-title>
        <v-text-field
          prepend-icon="search"
          v-model="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-card-text>
        <v-data-table
          class="px-5 py-3tabulardata"
          :headers="headers"
          :items="listItem"
          :page.sync="page"
          :items-per-page="itemsPerPage"
          :search="search"
          @page-count="pageCount = $event"
        >
          <template v-slot:item.name="{ item }">
            <div v-if="item.logo">
              <img
                :src="item.logo"
                style="width:60px; height:auto; vertical-align:middle;"
                :alt="item.name"
              />
              <span style="margin-left:20px;">{{ item.name }}</span>
            </div>
            <div v-else style="display:inline-block;">
              <v-icon style="font-size:60px !important; border-radius:none;">fa-image</v-icon>
              <span style="margin-left:20px;">{{ item.name }}</span>
            </div>
          </template>

          <template v-slot:item.action="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on:click.prevent="editItem(item)"
                  v-on="on"
                  fab
                  x-small
                  dark
                  color="primary"
                  class="mr-2"
                  depressed
                >
                  <v-icon dark>edit</v-icon>
                </v-btn>
              </template>
              <span>Edit</span>
            </v-tooltip>
          </template>
          <template v-slot:no-data>
            <p class="mb-0">No data.</p>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import { mapActions, mapGetters } from 'vuex'
import { BrandAPI } from '@/clients/product/brand.api'
export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      loaded: false,
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Name', value: 'name', sortable: true },
        { text: 'Description', value: 'description', sortable: true },
        { text: 'Actions', value: 'action', sortable: false, align: 'end' }
      ],
      listItem: []
    }
  },
  async created() {
    try {
      this.loaded = false
      await this.brandList();
      this.loaded = true
    } catch (err) {
      this.loaded = true
    }
  },
  watch: {
    editModal(value) {
      if (value == false) {
        this.brandList();
      }
    },
    addModal(value) {
      if (value == false) {
        this.brandList();
      }
    }
  },
  computed: {
    ...mapGetters({
      editModal: 'brand/editPop',
      addModal: 'brand/addPop'
    })
  },
  methods: {
    async brandList() {
      try{
        const { data: { payload } } = await BrandAPI.brandList()
        this.listItem = payload
      }catch(err){
        this.listItem = []
      }
    },
    /**
     * Edit popup setup
     */
    editItem(obj) {
      this.setEditPop(true)
      this.setEditObj(obj)
    },

    ...mapActions({
      setEditPop: 'brand/setEditPop',
      setEditObj: 'brand/setEditObj'
    })
  }
}
</script>
